import _classCallCheck from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Select/select';
import buttonStyles from '@patternfly/react-styles/css/components/Button/button';
import { css } from '@patternfly/react-styles';
import CaretDownIcon from '@patternfly/react-icons/dist/js/icons/caret-down-icon';
import { KeyTypes, SelectVariant } from './selectConstants';
export var SelectToggle =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SelectToggle, _React$Component);

  function SelectToggle(props) {
    var _this;

    _classCallCheck(this, SelectToggle);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelectToggle).call(this, props));

    _this.onDocClick = function (event) {
      var _this$props = _this.props,
          parentRef = _this$props.parentRef,
          isOpen = _this$props.isOpen,
          onToggle = _this$props.onToggle,
          onClose = _this$props.onClose;

      if (isOpen && parentRef && !parentRef.current.contains(event.target)) {
        onToggle(false);
        onClose();

        _this.toggle.current.focus();
      }
    };

    _this.onEscPress = function (event) {
      var _this$props2 = _this.props,
          parentRef = _this$props2.parentRef,
          isOpen = _this$props2.isOpen,
          variant = _this$props2.variant,
          onToggle = _this$props2.onToggle,
          onClose = _this$props2.onClose;

      if (event.key === KeyTypes.Tab && variant === SelectVariant.checkbox) {
        return;
      }

      if (isOpen && (event.key === KeyTypes.Escape || event.key === KeyTypes.Tab) && parentRef && parentRef.current.contains(event.target)) {
        onToggle(false);
        onClose();

        _this.toggle.current.focus();
      }
    };

    _this.onKeyDown = function (event) {
      var _this$props3 = _this.props,
          isOpen = _this$props3.isOpen,
          onToggle = _this$props3.onToggle,
          variant = _this$props3.variant,
          onClose = _this$props3.onClose,
          onEnter = _this$props3.onEnter,
          handleTypeaheadKeys = _this$props3.handleTypeaheadKeys;

      if ((event.key === KeyTypes.ArrowDown || event.key === KeyTypes.ArrowUp) && (variant === SelectVariant.typeahead || variant === SelectVariant.typeaheadMulti)) {
        handleTypeaheadKeys(event.key === KeyTypes.ArrowDown && 'down' || event.key === KeyTypes.ArrowUp && 'up');
      }

      if (event.key === KeyTypes.Enter && (variant === SelectVariant.typeahead || variant === SelectVariant.typeaheadMulti)) {
        if (isOpen) {
          handleTypeaheadKeys('enter');
        } else {
          onToggle(!isOpen);
        }
      }

      if (event.key === KeyTypes.Tab && variant === SelectVariant.checkbox || event.key === KeyTypes.Tab && !isOpen || event.key !== KeyTypes.Enter && event.key !== KeyTypes.Space || (event.key === KeyTypes.Space || event.key === KeyTypes.Enter) && (variant === SelectVariant.typeahead || variant === SelectVariant.typeaheadMulti)) {
        return;
      }

      event.preventDefault();

      if ((event.key === KeyTypes.Tab || event.key === KeyTypes.Enter || event.key === KeyTypes.Space) && isOpen) {
        onToggle(!isOpen);
        onClose();

        _this.toggle.current.focus();
      } else if ((event.key === KeyTypes.Enter || event.key === KeyTypes.Space) && !isOpen) {
        onToggle(!isOpen);
        onEnter();
      }
    };

    var variant = props.variant;
    var isTypeahead = variant === SelectVariant.typeahead || variant === SelectVariant.typeaheadMulti;
    _this.toggle = isTypeahead ? React.createRef() : React.createRef();
    return _this;
  }

  _createClass(SelectToggle, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('mousedown', this.onDocClick);
      document.addEventListener('touchstart', this.onDocClick);
      document.addEventListener('keydown', this.onEscPress);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.onDocClick);
      document.removeEventListener('touchstart', this.onDocClick);
      document.removeEventListener('keydown', this.onEscPress);
    }
  }, {
    key: "render",
    value: function render() {
      /* eslint-disable @typescript-eslint/no-unused-vars */
      var _a = this.props,
          className = _a.className,
          children = _a.children,
          isOpen = _a.isOpen,
          isActive = _a.isActive,
          isPlain = _a.isPlain,
          isDisabled = _a.isDisabled,
          variant = _a.variant,
          onToggle = _a.onToggle,
          onEnter = _a.onEnter,
          onClose = _a.onClose,
          handleTypeaheadKeys = _a.handleTypeaheadKeys,
          parentRef = _a.parentRef,
          id = _a.id,
          type = _a.type,
          hasClearButton = _a.hasClearButton,
          ariaLabelledBy = _a['aria-labelledby'],
          ariaLabel = _a['aria-label'],
          props = __rest(_a, ["className", "children", "isOpen", "isActive", "isPlain", "isDisabled", "variant", "onToggle", "onEnter", "onClose", "handleTypeaheadKeys", "parentRef", "id", "type", "hasClearButton", 'aria-labelledby', 'aria-label']);
      /* eslint-enable @typescript-eslint/no-unused-vars */


      var isTypeahead = variant === SelectVariant.typeahead || variant === SelectVariant.typeaheadMulti || hasClearButton;
      var toggleProps = {
        id: id,
        'aria-labelledby': ariaLabelledBy,
        'aria-expanded': isOpen,
        'aria-haspopup': variant !== SelectVariant.checkbox && 'listbox' || null
      };
      return React.createElement(React.Fragment, null, !isTypeahead && React.createElement("button", Object.assign({}, props, toggleProps, {
        ref: this.toggle,
        type: type,
        className: css(styles.selectToggle, isDisabled && styles.modifiers.disabled, isPlain && styles.modifiers.plain, isActive && styles.modifiers.active, className),
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        onClick: function onClick(_event) {
          onToggle(!isOpen);

          if (isOpen) {
            onClose();
          }
        },
        onKeyDown: this.onKeyDown,
        disabled: isDisabled
      }), children, React.createElement("span", {
        className: css(styles.selectToggleArrow)
      }, React.createElement(CaretDownIcon, null))), isTypeahead && React.createElement("div", Object.assign({}, props, {
        ref: this.toggle,
        className: css(styles.selectToggle, isDisabled && styles.modifiers.disabled, isPlain && styles.modifiers.plain, isTypeahead && styles.modifiers.typeahead, className),
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        onClick: function onClick(_event) {
          if (!isDisabled) {
            onToggle(true);
          }
        },
        onKeyDown: this.onKeyDown
      }), children, React.createElement("button", Object.assign({}, toggleProps, {
        type: type,
        className: css(buttonStyles.button, styles.selectToggleButton, styles.modifiers.plain),
        "aria-label": ariaLabel,
        onClick: function onClick(_event) {
          _event.stopPropagation();

          onToggle(!isOpen);

          if (isOpen) {
            onClose();
          }
        },
        disabled: isDisabled
      }), React.createElement(CaretDownIcon, {
        className: css(styles.selectToggleArrow)
      }))));
    }
  }]);

  return SelectToggle;
}(React.Component);
SelectToggle.defaultProps = {
  className: '',
  isOpen: false,
  isActive: false,
  isPlain: false,
  isDisabled: false,
  hasClearButton: false,
  variant: 'single',
  'aria-labelledby': '',
  'aria-label': '',
  type: 'button',
  onToggle: function onToggle() {},
  onEnter: function onEnter() {},
  onClose: function onClose() {}
};